var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 781 455.6",
    style: {
      enableBackground: "new 0 0 781 455.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M716,227.8c0,89.9-72.9,162.7-162.7,162.7l-58.5,0c-12.6,0-22.9,10.2-22.9,22.9v19.4 c0,12.6,10.2,22.9,22.9,22.9l58.5,0c125.8,0,227.8-102,227.8-227.8C781,102,679.1,0,553.2,0l-58.5,0c-12.6,0-22.9,10.2-22.9,22.9 l0,19.4c0,12.6,10.2,22.9,22.9,22.9l58.5,0C643.1,65.1,716,138,716,227.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.1,227.8c0,89.9,72.8,162.7,162.7,162.7h58.5c12.6,0,22.9,10.2,22.9,22.9l0,19.4c0,12.6-10.2,22.9-22.9,22.9 l-58.5,0C102,455.6,0,353.6,0,227.8C0,102,102,0,227.8,0l58.5,0c12.6,0,22.9,10.2,22.9,22.9l0,19.4c0,12.6-10.2,22.9-22.9,22.9 l-58.5,0C137.9,65.1,65.1,137.9,65.1,227.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M553.3,221c0-14.2-11.5-25.7-25.7-25.7l-274,0c-14.2,0-25.7,11.5-25.7,25.7l0,13.7c0,14.2,11.5,25.7,25.7,25.7 l274,0c14.2,0,25.7-11.5,25.7-25.7L553.3,221z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIcon);
export default __webpack_public_path__ + "static/media/linked_icon.8bcb9c95c09acf5d5c38d8d5c0d1c2c6.svg";
export { ForwardRef as ReactComponent };